module.exports = __webpack_public_path__ + "assets/img/tx101s_3.001b9921.jpg";